<template>
<div class="w-100 overflow-x-auto position-relative document-table-container">
      <v-simple-table
        v-if="unGroupedDocumentList && unGroupedDocumentList.length > 0"
        class="sticky-actions-table"
        dense
        fixed-header>
        <DocumentTableHeader v-on="$listeners" :fieldList="getDefaultVisibleHeaders()" />
        <DocumentTableRow
            v-for="document in unGroupedDocumentList"
            :documentDto="document"
            :headerFields="headerFields"
            :isSelected="document.ObjectID == selectedDocument"
            :totalDefaultVisibleFields="defaultVisibleFields"
            :selectedDocuments="selectedDocuments"
            :key="document.id"
            v-on="$listeners"
        />
      </v-simple-table>
      <template v-if="groupedDocumentList && groupedDocumentList.length > 0">
        <v-expansion-panels multiple accordion flat tile
            v-for="(groupedItem) in groupedDocumentList"
            :key="`${groupedItem.title}`">
            <DocumentGroupTable
                v-bind:key="groupedItem.title"
                :groupedItem="groupedItem"
                :totalDefaultVisibleFields="defaultVisibleFields"
                :selectedDocument="selectedDocument"
                :selectedDocuments="selectedDocuments"
                v-on="$listeners"
            />
      </v-expansion-panels>
      </template>
    </div>
</template>

<script>
import SortType from '@/ecm/variables/SortType';
import DocumentGroupTable from './DocumentGroupTable.vue';
import DocumentTableHeader from './DocumentTableHeader.vue';
import DocumentTableRow from './DocumentTableRow.vue';

export default {
    components: {
        DocumentTableHeader,
        DocumentTableRow,
        DocumentGroupTable
    },
    name: 'DocumentTable',
    props: {
        unGroupedDocumentList: {
            type: Array,
            default: () => []
        },
        groupedDocumentList: {
            type: Array,
            default: () => []
        },
        defaultVisibleFields: {
            type: Number
        },
        selectedDocument: {
            type: Number
        },
        selectedDocuments: {
            type: Array,
            default: () => []
        },
        latestCTVersionFields: {
            type: Array,
            required: true
        }
    },
    methods: {
        getDefaultVisibleHeaders() {
            return this.headerFields.map(x => ({
                code: x.Code,
                title: x.Title,
                sortOrder: SortType.Ascendent
            }));
        },
    },
    computed: {
        headerFields() {
            return this.latestCTVersionFields.slice(0, this.defaultVisibleFields);
        },
    }
};
</script>

<style lang="scss" scoped>
$actions-row-color: rgb(240, 240, 240);
::v-deep {
    .sticky-actions-table,
    .v-expansion-panel-content .v-simple-table {
        background: $actions-row-color;
        thead tr th:last-child {
            position: sticky;
            right: 0;
            background: $actions-row-color;
            z-index: 5;
        }

        tbody tr td:last-child {
            position: sticky;
            right: 0;
            background: $actions-row-color;
            z-index: 4;
            box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
        }

        tbody tr:hover td:last-child:not(.actions-fill-width) {
            background: #ebebeb;
        }

        tbody .row-extra_actions {
            position: relative;
            z-index: 5;
            td {
                position: relative !important;
                box-shadow: none !important;
                background: transparent !important;
            }
        }

        tbody .table-view_hidden-fields-row td:last-child {
            position: relative;
            box-shadow: none;
        }
    }
}
</style>